module.exports = __webpack_public_path__ + "./assets/img_ximen_color__63c8ac811331c714a65de8f5056c354b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ximen_color.jpg
// module id = 603
// module chunks = 12